import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, InputAdornment, TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import {
  useHotelDetailsQuery,
  useIsBookingExistLazyQuery,
} from '../generated/graphql';
import { MainWrapper } from '../Components/MainWrapper';
import { useSnackBar } from '../Components/Hooks/useSnackBar';
import SnackBarMsg from '../Components/SnackBar/SnackBarMsg';
import Loading from '../Components/Loading/Loading';

export default function HotelPreCheckInForm() {
  const queryParameters = new URLSearchParams(window.location.search);
  const URLHotelID = queryParameters.get('Hotel') as string;

  const navigate = useNavigate();
  const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();

  const [IsBookingno, setIsBookingno] = useState({ BookingNo: '' });

  const {
    loading: HotelLoadings,
    data: { HotelDetails } = { HotelDetails: null },
  } = useHotelDetailsQuery({
    variables: { HotelID: URLHotelID },
    fetchPolicy: 'no-cache',
  });

  const [loadBookingExist, { loading: BookingExistLoading }] = useIsBookingExistLazyQuery({
    fetchPolicy: 'no-cache',
    onError: error => {
      error.graphQLErrors.map(({ message }) => {
        snackFunc(
          'We are unable to find your booking. Please ensure your booking number is correct.',
          false
        );
      });
    },
    onCompleted: data => {
      navigate(data.IsBookingExist.FormUrl);
    },
  });

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleSearch = () => {
    loadBookingExist({
      variables: {
        BookingNo: IsBookingno?.BookingNo?.replace(/\s+/g, ''),
        HotelID: URLHotelID,
      },
    });
  };

  const inputRef = React.useRef<HTMLInputElement>(null)

  return HotelLoadings || BookingExistLoading ? (
    <Loading />
  ) : (
    <MainWrapper>
      <Box
        sx={{ p: 2, width: '100%', maxWidth: '800px' }}
        justifyContent="center"
        alignItems="center"
        margin="auto"
        bgcolor="#F7FAF7"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" mb="12px" alignItems="center" justifyContent="center">
              <img
                src={HotelDetails?.LogoImage?.ImageURL as any}
                alt="Hotel Logo"
                loading="lazy"
                width="180px"
              />
            </Box>
            <Typography fontSize="17px" fontWeight={600} mb="8px" align="center">
              {HotelDetails?.HotelName}
            </Typography>
            <Typography fontSize="13px" fontWeight={500} mb="12px" color="black" align="center">
              Search a booking to Pre-Checkin
            </Typography>
            <Typography fontSize="14px" fontWeight={600} mb="8px" align="center">
              Enter your booking number/Confirmation number.
            </Typography>
          </Grid>
        </Grid>
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '15vh',
          }}
          onKeyDown={handleKeyDown}
        >
          <TextField
            required
            label="Booking Number"
            inputRef={inputRef}
            value={IsBookingno?.BookingNo}
            onChange={e => setIsBookingno({ BookingNo: e.target.value })}
            variant="standard"
            InputLabelProps={{ style: { paddingLeft: '7px' } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label="close"
                    onMouseDown={e => e.preventDefault()}
                    onClick={() => {
                      setIsBookingno({ BookingNo: '' })
                      inputRef.current?.focus();  
                    }}
                    sx={{ paddingRight: '12px' }}
                  >
                    <CloseIcon style={{ fontSize: '17px', marginBottom: '15px' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ padding: '8px' }}
          />
        </Box>
        <Box
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            disabled={IsBookingno?.BookingNo === ''}
            sx={{
              backgroundColor: IsBookingno?.BookingNo === '' ? '#D3D3D3' : '#ff9800',
              '&:hover': { backgroundColor: '#ff9800' },
              '&:active': { backgroundColor: '#ff9800' },
              paddingLeft: '40px',
              paddingRight: '40px',
            }}
            onClick={handleSearch}
          >
            <Typography style={{ color: '#ffffff' }}>Search</Typography>
          </Button>
        </Box>
        <SnackBarMsg open={openSnackBar} message={snackBarMessage} />
      </Box>
    </MainWrapper>
  );
}
